<div class="modal-header">
    <div>
      <span class="title">View Matched Users for Request Id: {{selectedItem.requestId}}</span>
    </div>
    <div class="mt-2">
        <i class="icon-close" (click)="close()"></i>
    </div>
  </div>
  <div class="modal-body">
    <div class="search-user content grid-container" style="box-shadow: none !important;">
        <div *ngIf="matchedItems.length==0" class="text-container" style="margin-top: 20px;">
          No Data!
        </div>
        <div *ngIf="matchedItems.length>0" class="table-container">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Confidence Value</th>
                <th>Image</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of matchedItems">
                <td>{{ item?.firstName + ' ' + item?.lastName }}</td>
                <td>{{item?.email}}</td>
                <td>{{item?.confidenceValue}}</td>
                <td><img [src]="getSafeImageUrl(item?.photoUrl)" style="width: 100px; height: 100px; cursor: pointer;" alt="Photo"></td>
              </tr>
            </tbody>
          </table>
        </div>

  </div>
  </div>
